import { render } from "./topList.vue?vue&type=template&id=1f9b55d4&scoped=true"
import script from "./topList.vue?vue&type=script&lang=js"
export * from "./topList.vue?vue&type=script&lang=js"

import "./topList.vue?vue&type=style&index=0&id=1f9b55d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9b55d4"]])

export default __exports__